// extracted by mini-css-extract-plugin
export default {"wrapper":"NoDataFound_wrapper__+IrQW","title":"NoDataFound_title__xfIhc","content":"NoDataFound_content__PI+qR"};